import { IBasePickerSuggestionsProps } from '@fluentui/react';
import ICompanyGroupStatUsers from './types/ICompanyGroupsStatUsers';
import IPersonaWithGUID from './types/IPersonaWithGUIDs';

export const suggestionProps: IBasePickerSuggestionsProps = {
  loadingText: 'Loading',
  searchingText: 'Searching...',
};

export const mapCompanyGroupsStatUserToStatPersonas = (
  cgsus: ICompanyGroupStatUsers[],
): IPersonaWithGUID[] => {
  return cgsus.map((cgsu: ICompanyGroupStatUsers) => {
    const persona: ICompanyGroupStatUsers = {
      text: cgsu.name,
      secondaryText: cgsu.email,
      graphId: cgsu.graphId,
      firstName: cgsu.firstName,
      lastName: cgsu.lastName,
      alias: cgsu.alias,
      personnelNumber: cgsu.personnelNumber,
    };
    return persona;
  });
};
export const mapPersonasToCompanyGroupUser = (
  personas: IPersonaWithGUID[],
  companyGroupId: number,
): ICompanyGroupStatUsers[] =>
  personas.map((persona) => {
    return {
      graphId: persona.graphId,
      name: persona.text,
      email: persona.secondaryText,
      firstName: persona.firstName,
      lastName: persona.lastName,
      alias: persona.alias,
      personnelNumber: persona.personnelNumber,
    };
  });
